import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MANIFESTO, IMAGES } from "../data";
import { Reveal } from "./Reveal";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="approach" data-testid="manifesto" className="relative bg-pine text-bone py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-[1px] w-10 bg-terra" />
                <span className="text-bone/60 text-xs uppercase tracking-[0.3em]">Our approach</span>
              </div>
              <Reveal>
                <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                  Owner-operated.<br />No corners cut.
                </h2>
              </Reveal>
              <p className="mt-6 text-bone/70 leading-relaxed max-w-md">
                We believe in hard work, honest service, and fair pricing — and in leaving every
                property better than we found it.
              </p>
              <div className="img-clip mt-10 aspect-[4/3] hidden lg:block border border-white/10">
                <motion.img style={{ y }} src={IMAGES.house} alt="Property" className="w-full h-[124%] object-cover" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            {MANIFESTO.map((m) => (
              <Reveal key={m.n}>
                <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-9 border-b border-white/10 items-start">
                  <span className="font-display font-black text-terra/90 text-6xl md:text-8xl leading-none tracking-tighter">
                    {m.n}
                  </span>
                  <div className="pt-2">
                    <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">{m.title}</h3>
                    <p className="mt-3 text-bone/70 leading-relaxed text-base md:text-lg max-w-lg">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
